
import React, { useState } from 'react';
import { Navigate, Route, Routes, useNavigation, useParams } from 'react-router-dom';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import PageLayout from '../../components/PageLayout';
import { CollectionServerMobile, GET, GETWITH, JSXMap, QueryParam, errorCatch, useAuth } from 'fennec-ui';
import { BreadcrumbsProvider, NearestObjectContext } from '../../../common/Context';
import { SpinLoading } from 'antd-mobile';
import { Empty } from 'antd';
import Error404, { Error404Element } from '../../../desktop/components/Error404';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

export function ContextItem(props) {
    let { id } = useParams();
    const { source, params, children, display, displayString } = props;
    const auth = useAuth()
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    
    const [contextObject, setContextObject] = React.useState()
    React.useEffect(() => {
        setLoaded(false)
        if (source && _.isFunction(source)) {
            // lock();
            source({
                lock: () => { setLoading(true) },
                unlock: () => { setLoading(false) },

                page: 0,
                count: 0,
                sorting: undefined,
                filter: undefined,
                // {stat, totalPages, size, totalElements, content}
                apply: (data) => {
                    let d = data.content || data;
                    if (d?.length >= 1) {
                        setContextObject(d.find(e => e.ID == id));
                    }
                    setLoaded(true)
                }
            });
        } else if (source && !_.isFunction(source)) {
            if (!isNaN(parseInt(id))) {
                GETWITH(auth, source, [
                    QueryParam("w-ID", id),
                    ...((params) ? params : [])
                ], ({ data }) => {
                    if (data?.length >= 1) {
                        setContextObject(data[0]);
                    }
                    setLoaded(true)
                }, (err) => errorCatch(err, () => setLoaded(true)))
            }
        }
    }, [id, source])

    return (<>
        {(contextObject && loaded) && <NearestObjectContext.Provider value={[contextObject, setContextObject]}>
            <BreadcrumbsProvider value={(contextObject) ? {
                uuid: id,
                name: displayString(contextObject),
                context: true
            } : undefined}>
                {children}
            </BreadcrumbsProvider>
        </NearestObjectContext.Provider>}
        {(!contextObject && loaded) && <Error404 />}
    </>)
}


export function ContextList(props) {
    const { source, params, display, displayString, title, empty, count, style } = props;
    const auth = useAuth()
    const contentStyle = {
        padding: 50,
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 4,
    };
    const content = <div style={contentStyle} />;

    const FilterFromContextFilter = React.useCallback(() => [
        ...(params) ? params : []
    ], [params]);
    return (<PageLayout hideSider={true} /*hideBreadcrumbs={true}*/>
        <div style={{
            padding: "5px 10px", backgroundColor: "white", borderRadius: "4px",
            ...(style) ? style : {}
        }}>
            <ContextGroupItem {...props} />
        </div>
    </PageLayout>)
}
export function ContextGroupItem(props) {
    const { source, params, display, displayString, title, empty, count } = props;
    const auth = useAuth()
    const contentStyle = {
        padding: 50,
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 4,
    };
    const content = <div style={contentStyle} />;

    const FilterFromContextFilter = React.useCallback(() => [
        ...(params) ? params : []
    ], [params]);

    return (
        <CollectionServerMobile
            count={count}
            auth={auth}
            // name={"DvizheniyaDeneg"}
            // queryDetail={"collection"}
            source={source}
            // filters={filters}
            contextFilters={FilterFromContextFilter}
            size={"small"}
            noheader={true}
            mode={"list"}

            customRender={(items, {
                collection,
                setCollection,
                setCollectionItem,
                removeCollectionItem,
                collectionActions,
                modelActions,
                update,
                loading
            }) => (<div>
                {loading && <div style={{display:"flex", justifyContent:"center"}}><SpinLoading tip="Загрузка" size="large">
                    {content}
                </SpinLoading></div>}
                {!loading && <div>
                    {title}
                    {(items?.length <= 0) && <div><Empty description={"Нет данных"} style={{ padding: "40px 0px" }} /></div>}
                    {(items && items?.length > 0) && JSXMap(items, (e, idx) => {
                        return (<div key={e.ID} style={{ width: "100%" }}>
                            {display(e)}
                        </div>)
                    })}
                </div>}
            </div>)}
        />
    )
}

export function ContextGroup(props) {
    const { children, grouptitle, style } = props;

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { ...props, ...child.props });
        }
        return child;
    });
    return (<PageLayout hideSider={true} /*hideBreadcrumbs={true}*/>
        <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px", ...(style) ? style : {} }}>
            {grouptitle}
            {childrenWithProps}
        </div>
    </PageLayout>);
}

export default function ContextRoute(props) {
    const { uuid, list, item, children, itemSource, listSource, params, display, displayString } = props;

    // const childrenWithProps = React.Children.map(children, child => {
    //     if (React.isValidElement(child)) {
    //         return React.cloneElement(child, { ...props, params: params, display: display, displayString: displayString, source: itemSource, ...child.props });
    //     }
    //     return child;
    // });
    const listWithProps = ((React.isValidElement(list))) ? React.cloneElement(list, { ...props, params: params, display: display, displayString: displayString, source: listSource, ...list.props }) : list;
    const itemWithProps = ((React.isValidElement(item))) ? React.cloneElement(item, { ...props, params: params, display: display, displayString: displayString, source: itemSource, ...item.props }) : item;
    return (<Routes>
        {list && <Route key={"index-list"} index element={<Navigate replace to={"list"} />} />}
        {list && <Route key={uuid + "list"} path={"list"} element={listWithProps} />}
        {(item && !children) && <Route key={uuid} path={uuid + "/*"} element={<ContextItem source={itemSource} params={params} display={display} displayString={displayString} {...item.props} >{itemWithProps}</ContextItem>} />}
        {/* {(!item && children) && <Route key={uuid} path={uuid + "/*"} element={<ContextItem source={itemSource} params={params} display={display} displayString={displayString}>{childrenWithProps}</ContextItem>} />} */}
    </Routes>);
}
